import { createSelector } from 'reselect';
const selectSignup = (state) => state.getIn(['me', 'signup']);

const makeSelectSignupLoading = () => createSelector(selectSignup, (state) => state.get('loading'));

const makeSelectSignupError = () => createSelector(selectSignup, (state) => state.get('error'));

export { makeSelectSignupLoading, makeSelectSignupError };
